// extracted by mini-css-extract-plugin
export default {"loginFormWrapper":"styles_loginFormWrapper__a+tqx","login__container":"styles_login__container__J2If7","login__content":"styles_login__content__ShH3v"};